// components/EditModal.js
import {Form, InputNumber, message, Modal, Radio, Switch} from "antd";
import {memo, useEffect, useMemo} from "react";
import {months, parseCostString} from "../../utils/costUtils";

export const EditModal = memo(({visible, record, onClose, onSave}) => {
    const [form] = Form.useForm();
    const initialValues = useMemo(() => {
        if (!record) return {};
        const monthlyCosts = parseCostString(record.cost);
        return {
            obj_name: record.obj_name,
            type: record.type,
            balance: record.balance,
            enable: record.enable === 1,
            nds: record.nds,
            january: monthlyCosts[0] || 0,
            february: monthlyCosts[1] || 0,
            march: monthlyCosts[2] || 0,
            april: monthlyCosts[3] || 0,
            may: monthlyCosts[4] || 0,
            june: monthlyCosts[5] || 0,
            july: monthlyCosts[6] || 0,
            august: monthlyCosts[7] || 0,
            september: monthlyCosts[8] || 0,
            october: monthlyCosts[9] || 0,
            november: monthlyCosts[10] || 0,
            december: monthlyCosts[11] || 0,
        };
    }, [record]);

    useEffect(() => {
        if (visible && record) {
            form.setFieldsValue(initialValues);
        }
    }, [visible, record, form, initialValues]);

    const handleOk = async () => {
        try {
            const values = await form.validateFields();

            // Собираем месячные стоимости в строку
            const monthlyCosts = [
                values.january || 0,
                values.february || 0,
                values.march || 0,
                values.april || 0,
                values.may || 0,
                values.june || 0,
                values.july || 0,
                values.august || 0,
                values.september || 0,
                values.october || 0,
                values.november || 0,
                values.december || 0,
            ].join('`');

            const updatedData = {
                id: record.id,
                type: values.type,
                balance: values.balance,
                enable: values.enable ? 1 : 0,
                nds: values.nds,
                cost: monthlyCosts
            };

            await onSave(updatedData);
            message.success('Данные успешно сохранены');
        } catch (error) {
            console.error('Validation failed:', error);
            message.error('Ошибка при сохранении данных');
        }
    };

    if (!record) return null;

    return (
        <Modal
            title={`Редактирование: ${record.obj_name || ''}`}
            open={visible}
            onOk={handleOk}
            onCancel={onClose}
            width={800}
            okText="Сохранить"
            cancelText="Отмена"
        >
            <Form
                form={form}
                layout="vertical"
            >
                <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px'}}>
                    <Form.Item
                        name="type"
                        label="Форма оплаты"
                        rules={[{required: true, message: 'Выберите форму оплаты'}]}
                    >
                        <Radio.Group>
                            <Radio value={1}>Наличная</Radio>
                            <Radio value={2}>Безналичная</Radio>
                        </Radio.Group>
                    </Form.Item>

                    <Form.Item
                        name="enable"
                        label="Статус объекта"
                        valuePropName="checked"
                    >
                        <Switch
                            checkedChildren="Активен"
                            unCheckedChildren="Неактивен"
                        />
                    </Form.Item>

                    <Form.Item
                        name="balance"
                        label="Текущий баланс (€)"
                        rules={[{required: true, message: 'Введите баланс'}]}
                    >
                        <InputNumber
                            style={{width: '100%'}}
                            precision={2}
                            placeholder="0.00"
                        />
                    </Form.Item>

                    <Form.Item
                        name="nds"
                        label="НДС (%)"
                        rules={[{required: true, message: 'Введите НДС'}]}
                    >
                        <InputNumber
                            style={{width: '100%'}}
                            min={0}
                            max={100}
                            precision={0}
                            placeholder="0"
                        />
                    </Form.Item>
                </div>

                <div style={{marginTop: '16px'}}>
                    <h4 style={{marginBottom: '16px'}}>Помесячная стоимость (€)</h4>
                    <div style={{display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '12px'}}>
                        {months.map((month, index) => (
                            <Form.Item
                                key={month.en}
                                name={month.en}  // Используем английское название для name
                                label={month.ru} // Показываем русское название в label
                            >
                                <InputNumber
                                    style={{width: '100%'}}
                                    precision={2}
                                />
                            </Form.Item>
                        ))}
                    </div>
                </div>
            </Form>
        </Modal>
    );
});

EditModal.displayName = 'EditModal';